import { render, staticRenderFns } from "./BikyConfigChatAudioMessage.vue?vue&type=template&id=3ae41c73&scoped=true&"
import script from "./BikyConfigChatAudioMessage.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigChatAudioMessage.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigChatAudioMessage.vue?vue&type=style&index=0&id=3ae41c73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae41c73",
  null
  
)

export default component.exports